import uniqueId from 'lodash/uniqueId'
import { StrictMode, useRef } from 'react'
import type { VFC } from 'react'
import { Theme } from '@opallabs/gem'
import { kuiperClassNames } from '@opallabs/kuiper'
import { Icon, InputLabel, Tooltip, Button } from '@opallabs/lapidary'
import BackgroundUploader from '../../../BackgroundUploader/index.js'
import * as styles from '../styles'
import type { SidebarProps } from '../types'

export type Props = Pick<SidebarProps, 'backgroundAssetReference' | 'theme'> &
  Readonly<{
    onChange(value: File | null): void
  }>

const infoButton = (theme: Theme) => (
  <Tooltip
    content="This will replace custom background images used by presentation themes."
    legacyTheme={theme}
    zIndex={100}
    contentStyles={{ width: 225 }}
    side="bottom"
  >
    <Button
      name="Slide background info"
      icon={<Icon ariaHidden={true} glyph="gem-info-circle" />}
      variant="ghost"
      css={styles.buttonOverrides}
      ariaLabel="Slide background info"
    />
  </Tooltip>
)

export const BackgroundAssetSection: VFC<Props> = ({
  backgroundAssetReference,
  onChange,
  theme = 'light',
}) => {
  const htmlId = useRef(uniqueId('sidebar-background-image'))

  return (
    <StrictMode>
      <div className={kuiperClassNames('file-upload')}>
        <InputLabel
          inputId={htmlId.current}
          styleOverrides={styles.label(theme)}
          text="Background"
          theme={theme}
        >
          {infoButton(theme)}
        </InputLabel>

        {!backgroundAssetReference && (
          <div className={kuiperClassNames('instructions')}>
            Upload a custom background for this slide
          </div>
        )}
        <BackgroundUploader
          buttonText="Upload"
          onUpload={(file: File): void => onChange(file)}
          onDelete={() => onChange(null)}
          assetReference={backgroundAssetReference}
          htmlId={htmlId.current}
          theme={theme}
        />
      </div>
    </StrictMode>
  )
}
BackgroundAssetSection.displayName =
  'Hubble: BackgroundAssetSection ← Sidebar ← SlideEditor'
